import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AccountPhoneChangeComponent } from './account-phone-change.component';
import { OtpVerificationModule } from '../otp-verification/otp-verification.module';
import { PhoneNumberFormatModule } from 'src/app/libs/ui/pipes/phone-number-format/phone-number-format.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [AccountPhoneChangeComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    OtpVerificationModule,
    PhoneNumberFormatModule,
    TranslateModule
  ],
  exports: [AccountPhoneChangeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],

})
export class AccountPhoneChangeModule {}
